const ProductGridEl = document.getElementById('product-grid')
const ProductGridApp = Vue.createApp({
    components: {
        'product': ProductGridItem,
        'currency': ProductGridPrice,
        'modal': QuickViewModal, 
        'notify': NotifyMeModal,
        'media': ProductGridVideo
    },
    props: ['id'],
    data() {
        return {
            filtered: false,
            tags: 0,
            products: [],
            videoObj: null,
            featuredOffers: [],   // array of { html, link, position }
            i18n: {},
            cartAddUrl: '/cart/add.js',
            showModal: false,
            showNotify: false,
            modalLoading: false,
            notifyLoading: false,
            notifySuccess: false,
            quickViewItem: {},
            notifyItem: null,
            quickViewItems: {},
            productsLoading: false,
        }
    },
    created() {
        this.fetchHeaders = new Headers();
        this.fetchHeaders.append('pragma', 'no-cache');
        this.fetchHeaders.append('cache-control', 'no-store');
        this.fetchHeaders.append('Content-Type', 'application/json');
        this.cartNotification = document.querySelector('cart-notification');
        try {
            const productDataJson = document.getElementById('product-data').innerText;
            // Paint the grid right away with the US default instead of waiting on the
            // country lookup (the first card image is the page's LCP). updateLocations
            // mutates the products, so the real-country pass below works on a fresh copy
            // and replaces this one when it resolves.
            const initialData = JSON.parse(productDataJson);
            this.updateLocations(initialData, 'US').then(() => {
                if (this.products.length === 0) {
                    this.products = initialData.filter(product => product.found === true)
                        .sort((a,b) => b.available - a.available);
                }
            });
            let data = JSON.parse(productDataJson);
            this.updateLocations(data).then(() => {
                data = data.filter(product => product.found === true);
                data.sort((a,b) => b.available - a.available);
                this.products = data;
            });
            const collectionFeaturedVideo = document.getElementById('collection-featured-video');
            if(collectionFeaturedVideo) {
                this.videoObj = JSON.parse(collectionFeaturedVideo.innerText);
            }
            const productGridContainer = document.getElementById('ProductGridContainer');
            if(productGridContainer && productGridContainer.dataset.currentTags) {
                this.tags = parseInt(productGridContainer.dataset.currentTags);
            }
            // Read up to 2 offer divs (index 0 and 1)
            for (let i = 0; i < 2; i++) {
                const el = document.getElementById('collections-featured-offer-' + i);
                if (el) {
                    const linkEl = el.querySelector('a');
                    this.featuredOffers.push({
                        html:     el.innerHTML,
                        link:     linkEl ? linkEl.getAttribute('href') : null,
                        position: parseInt(el.dataset.position, 10) || 4
                    });
                }
            }
        } catch (e) {
            console.error("Error parsing JSON from #product-data:", e);
        }
        if(window.evanhealy_settings && window.evanhealy_settings.i18n) {
            this.i18n = window.evanhealy_settings.i18n;
        }
        window.addEventListener('ehUpdateProducts', (e) => {
            let data = e.detail.products;
            this.updateLocations(data).then(() => {
                data = data.filter(product => product.found === true);
                data.sort((a,b) => b.available - a.available);
                this.products = data;
            });
            this.tags = e.detail.tags;
            this.filtered = true;
        })
        window.addEventListener('ehAddProducts', (e) => {
            let data = e.detail.products;
            this.updateLocations(data).then(() => {
                data = data.filter(product => product.found === true);
                data.sort((a,b) => b.available - a.available);
                this.products = this.products.concat(data);
            });
            this.tags = e.detail.tags;
            this.filtered = true;
            this.productsLoading = false;
        })
        window.addEventListener('ehProductsStartLoading', (e) => {
            this.productsLoading = true;
        })
        window.addEventListener('ehProductsStopLoading', (e) => {
            this.productsLoading = false;
        })
    },
    computed: {
    },
    methods: {
        addToCart(qty,variantId,gridItem) {
            const data = {
                items: []
            };
            const item = {id: variantId, quantity: qty};
            data.items.push(item);
            const body = JSON.stringify(data);
            this.modalLoading = true;
            this.products.forEach((product) => {
                if(product.id === gridItem.id) {
                    product.loading = true;
                    product.error = null;
                }
            });
            fetch(this.cartAddUrl,{method: 'POST', headers: this.fetchHeaders , body})
                .then((response) => response.json())
                .then((parsedState) => {
                    this.showModal = false;
                    this.modalLoading = false;
                    if(parsedState.status) {
                        // Add rejected (e.g. quantity over a b2b catalog limit -> HTTP 422).
                        // Show the reason on the card and bail before opening the cart
                        // drawer, which would otherwise lock page scroll with nothing to show.
                        this.setProductError(gridItem, parsedState.message || parsedState.description);
                        return;
                    }
                    this.updateCart(parsedState);
                })
                .catch((e) => {
                    console.error(e);
                }).finally(() => {
                this.modalLoading = false;
                this.products.forEach((product) => {
                    product.loading = false;
                });
            });
        },
        updateCart(response) {
            const event = new CustomEvent("ehAddProductToCart", {detail: response});
            window.dispatchEvent(event);
            this.cartNotification.renderContents(response);
        },
        setProductError(gridItem, message) {
            this.products.forEach((product) => {
                if(product.id === gridItem.id) {
                    product.error = message;
                    // Auto-dismiss so the message doesn't linger on the card indefinitely.
                    clearTimeout(product._errorTimeout);
                    product._errorTimeout = setTimeout(() => { product.error = null; }, 5000);
                }
            });
        },
        decodeHtml(html) {
            const txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        openQuickView(item) {
            if(this.quickViewItems.hasOwnProperty(item.id)) {
                this.showQuickViewModal(this.quickViewItems[item.id])
            } else {
                const url = '/products/' + item.handle + '.js'
                fetch(url)
                    .then(response => response.json())
                    .then((response) => {
                        response['certification_logos'] = this.decodeHtml(item.certification_logos);
                        response['subtitle'] = item.subtitle;
                        response['short_description'] = item.short_description;
                        response['benefits'] = item.benefits;
                        response['selected_or_first_available_variant'] = item.selected_or_first_available_variant;
                        response['selected_or_first_available_selling_plan'] = item.selected_or_first_available_selling_plan;
                        response['variants'] = item.variants;
                        this.quickViewItems[item.id] = response;
                        this.quickViewItems[item.id] = response;
                        this.quickViewItem = response; 
                        this.showQuickViewModal(response);
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
        },
        openNotifyModal(item) {
            document.body.classList.add('overflow-hidden');
            this.showNotify = true;
            this.notifyItem = item;
        },
        submitNotify(email,variantId) {
            if(!email || !variantId) {
                return false;
            }
            this.notifyLoading = true;
            backInStockSubscription(email,variantId)
                .then((response) => {
                    this.notifySuccess = true;
                    this.notifyLoading = false;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.notifyLoading = false;
                });
        },
        showQuickViewModal(item) {
            document.body.classList.add('overflow-hidden');
            this.showModal = true;
            this.quickViewItem = item;
            this.updateReviewsText();
        },
        clickFeaturedOffer(event, link) {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if(width > 749 && link) {
                event.stopPropagation();
                window.open(link, '_blank');
            }
        },
        updateReviewsText() {
          function updateElements() {
            let count = 0;
            const timer = setInterval(function() {
              const elements = document.querySelectorAll('.junip-product-summary-review-count');
              if (elements.length > 0) {
                elements.forEach((element => {
                  let html = element.innerHTML.trim().replace('(', '').replace(')', '');
                  if (!isNaN(html)) {
                    html = parseInt(html);
                    element.innerHTML = `Read ${html} ${html > 1 ? 'reviews' : 'review'}`;
                  }
                }));
              }
              count += 500;
              if (count > 5000) clearInterval(timer);
            }, 500);
          }
          updateElements();
          window.addEventListener('resize', function(event) {
            updateElements();
          }, true);
          window.addEventListener('orientationchange', function(event) {
            updateElements();
          }, true);
        }
    },
    template: `
            <p v-if="products.length === 0" class="empty-collection">No products found in this collection</p>
            <ul class="grid grid--2-col product-grid grid--3-col-tablet grid--one-third-max grid--4-col-desktop grid--quarter-max">
                <template v-for="(product, index) in products" :key="product.id">
                <template v-if="product.title.toLowerCase() !== 'tea tree gel cleanser - copy'">
                    <template v-if="index === 2 && videoObj && tags === 0">
                        <media :media="videoObj"></media>
                    </template>
                    <template v-for="offer in featuredOffers" :key="'offer-' + offer.position">
                        <template v-if="index === offer.position && tags === 0">
                            <li class="grid__item grid__video"
                                @click="clickFeaturedOffer($event, offer.link)"
                                v-html="offer.html">
                            </li>
                        </template>
                    </template>
                    <li class="grid__item this">    
                        <product
                             :item="product"
                             :i18n="i18n"
                             @add-to-cart="addToCart"
                             @open-quick-view="openQuickView"
                             @open-notify-modal="openNotifyModal"
                        ></product>         
                    </li>
                    </template>
                </template>
                <template v-if="productsLoading">
                    <li v-for="n in 12" :key="n" class="grid__item"><div class="placeholder-container"><div class="content"></div></div></li>
                </template>
            </ul>
            <modal v-if="products.length > 0" :show="showModal" :loading="modalLoading" :item="quickViewItem" @add-to-cart="addToCart" @close="showModal = false"></modal>
            <notify v-if="products.length > 0" :show="showNotify" :loading="notifyLoading" :submitted="notifySuccess" :item="notifyItem" @submit-notify="submitNotify" @close="showNotify = false; notifySuccess = false;"></notify>`
}, { ...ProductGridEl.dataset })
ProductGridApp.use(ehPlugin);
ProductGridApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api')
ProductGridApp.config.unwrapInjectedRef = true
ProductGridApp.mount('#product-grid')
